module.exports = __webpack_public_path__ + "media/images/cv/mail_logo-8f2a8626d547ffc21e310c049ad17428.png";